import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShieldCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconShieldCheck"><Path fillRule="evenodd" clipRule="evenodd" d="M3 5L12 2L21 5V11.9529C21 14.6903 19.8165 16.7106 18.1412 18.3002C16.4942 19.863 14.3404 21.038 12.3561 22.1086L12 22.3007L11.6439 22.1086C9.65956 21.038 7.5058 19.863 5.85876 18.3002C4.18351 16.7106 3 14.6903 3 11.9529V5ZM15.8107 9.54102L14.75 8.48036L11 12.2304L9.25 10.4804L8.18934 11.541L11 14.3517L15.8107 9.54102Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShieldCheck;
